import { Outlet } from "react-router-dom";
import { Col, Row } from "antd";
import Logo from "@Assets/images/main-logo.png";
import styles from "./index.module.scss";

const AuthLayout = () => {
  return (
    <div className={`${styles["wrapper-container"]} `}>
      <Row>
        <Col
          xs={0}
          sm={0}
          md={0}
          lg={10}
          xl={10}
          xxl={10}
          className="hidden"
        ></Col>
        <Col xs={24} sm={24} md={24} lg={14} xl={14} xxl={14}>
          <div className="flex flex-col items-center">
            <div className="pt-4 sm:pt-12 md:pt-[82px] lg:pt-8 xl:pt-12 2xl:pt-[82px] flex flex-col items-center justify-center px-4">
              <img 
                src={Logo} 
                alt="" 
                className="w-[150px] h-auto sm:w-[150px] md:w-[150px] lg:w-[180px] xl:w-[200px] 2xl:w-[230px]"
              />
              <p className="!text-[#F1F1F1] mt-2 max-w-xl font-[400] text-xs sm:text-sm md:text-[14px] py-2 sm:py-3 !font-inter text-center">
                Admin Dashboard
              </p>
            </div>
            <div className="pt-2  w-full">
              <Outlet />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default AuthLayout;
